import { SubscriptionServices, SubscriptionTiers, SubscriptionTierVersion } from './subscription-tier'
import { UserDiscount } from './user-discount'

export const SubscriptionStatus = {
    Active: 'Active',
    Cancelled: 'Cancelled',
    Failed: 'Failed',
    Incomplete: 'Incomplete',
    IncompleteExpired: 'IncompleteExpired',
    PastDue: 'PastDue',
    Pending: 'Pending',
    Unpaid: 'Unpaid',
} as const

export type SubscriptionStatusTypes = (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus]

export const SubscriptionStatusLabels: Record<SubscriptionStatusTypes, string> = {
    Active: 'Activa',
    Cancelled: 'Cancelada',
    Failed: 'Errónea',
    Incomplete: 'Incompleta',
    IncompleteExpired: 'Incompleta y expirada',
    PastDue: 'Vencida',
    Pending: 'Pendiente',
    Unpaid: 'No pagada',
}

export interface Subscription {
    userDiscounts: UserDiscount[]
    id: number
    userId: number
    currencyCode: string
    amount: number
    subscriptionServices: SubscriptionServices[] | null
    hiredWorkers: number
    subscriptionCurrentPeriodStart: string
    subscriptionCurrentPeriodEnd: string
    startDateUTC: string
    cancellationDateUTC: string
    cancellationRequestedDateUTC: string
    status: SubscriptionStatusTypes
    subscriptionTierType: SubscriptionTiers
    pricingVersion: SubscriptionTierVersion
}

export const SubscriptionTaxRegimes = {
    Standard: 'Standard',
    CanaryIslands: 'CanaryIslands',
} as const

export type SubscriptionTaxRegime = (typeof SubscriptionTaxRegimes)[keyof typeof SubscriptionTaxRegimes]
